import React from "react";
import { Row, Col, Card, Form, Input, Button, message } from "antd";
import bg from "Assets/login_bg.jpg";
import auth from "Api/auth";
import { setAuthStorage } from "Utils/authUtils";
import { useHistory, Redirect } from "react-router-dom";
import { useAuthState, useAuthDispatch } from "Contexts/Auth";
const Login = () => {
  const { isLoggedIn } = useAuthState();
  const dispatch = useAuthDispatch();
  const { mutate, result } = auth.useLogin();
  const [form] = Form.useForm();
  const history = useHistory();
  if (isLoggedIn) return <Redirect to="/" />;
  return (
    <Row
      align="middle"
      style={{
        minHeight: "100vh",
        backgroundImage: `url(${bg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <Col
        span={22}
        offset={1}
        md={{ span: 16, offset: 4 }}
        lg={{ span: 8, offset: 1 }}
      >
        <Card
          title="ورود به پورتال مدیریت آزمایشگاه"
          headStyle={{ textAlign: "center" }}
        >
          <Form
            form={form}
            onFinish={(values) => {
              mutate({
                type: "post",
                body: values,
                onSuccess(res) {
                  message.success("با موفقیت وارد شدید");
                  dispatch({
                    type: "loggedIn",
                    data: { name: res.user.name, role: res.user.roles[0].name },
                  });
                  setAuthStorage({
                    role: res.user.roles[0].name,
                    name: res.user.name,
                    isLoggedIn: true,
                  });
                  history.replace("/");
                },
                onError() {
                  message.error("نام کاربری یا رمز عبور نادرست وارد شده است");
                },
              });
            }}
            labelCol={{ md: { span: 6 }, xs: { span: 4 } }}
            wrapperCol={{ md: { span: 18 }, xs: { span: 20 } }}
          >
            <Form.Item label="نام کاربری" name="email">
              <Input placeholder="نام کاربری را وارد کنید" />
            </Form.Item>
            <Form.Item label="رمز عبور" name="password">
              <Input type="password" placeholder="رمز عبور را وارد کنید" />
            </Form.Item>
            <Form.Item
              style={{ textAlign: "center" }}
              labelCol={{ span: 0 }}
              wrapperCol={{ span: 24 }}
            >
              <Button
                loading={result.isLoading}
                type="primary"
                htmlType="submit"
              >
                ورود
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default Login;
